export const LABELS = {
  BEDROOMS: 'bedrooms',
  BATHROOMS: 'bathrooms',
  CARSPACES: 'car spaces',
  RENT_PW: 'Rent pw',
};
